import { useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import moment from "moment";
import "./CustomEvent.scss";
import RescheduleSlotModal from "./RescheduleSlotModal";
import { SessionKeys } from "../../../utils/AppUtils";

const CustomEvent = ({ event, deleteSlotApi, setShow, handleReschedule }) => {
  console.log("event", event.isCancelled,event);

  function is48HoursOrMore(startTime) {
    const currentTime = moment();
    const timeDiff = moment(startTime).diff(currentTime, "hours");
    return timeDiff >= 48;
  }

  const startTimeFormat = moment(event.start).format("h:mm a");
  const endTimeFormat = moment(event.end).format("h:mm a");
  console.log("eventxx", startTimeFormat, endTimeFormat, event);

  const [showTooltip, setShowTooltip] = useState(false);

  const handleMouseEnter = () => {
    setShowTooltip(true); // Show tooltip on hover
  };

  const handleMouseLeave = () => {
    setShowTooltip(false); // Hide tooltip when mouse leaves
  };

  const tooltipContentJoin = (
    <Tooltip id={`tooltip-${event.id}`} className="customtol jointool">
      <div className="tooltipiner">
        <div className="d-flex align-items-start">
          <div className="text-nowraptitl">Session with End user</div>
        </div>
        <div className="d-flex align-items-start">
          <div className="dsfedat">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
            >
              <path
                d="M14.6666 7.99967C14.6666 11.6797 11.6799 14.6663 7.99992 14.6663C4.31992 14.6663 1.33325 11.6797 1.33325 7.99967C1.33325 4.31967 4.31992 1.33301 7.99992 1.33301C11.6799 1.33301 14.6666 4.31967 14.6666 7.99967Z"
                stroke="#7E7E7E"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M10.4734 10.1202L8.40675 8.88684C8.04675 8.6735 7.75342 8.16017 7.75342 7.74017V5.00684"
                stroke="#7E7E7E"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>{" "}
            {`${startTimeFormat} -> ${endTimeFormat}`}
          </div>
        </div>
        <div className="d-flex align-items-start particidsec">
          <p className="mb-0">End user</p>
        </div>
        <div className="d-flex gap-2 align-items-center borderbxo mt-3">
          <div className="img-box-ecclipse">
            <img
              src={event.profile ? event.profile : "/images/avatar.svg"}
              className="imgbx"
              alt="End user"
              loading="lazy"
            />
          </div>
          <div className="fnts">Session with {event.name}</div>
        </div>
        <div className="linkdf mt-3">
          <a
            href={event.url ? event.url : ""}
            target="_blank"
            rel="noopener noreferrer"
            className="d-flex align-items-center gap-1"
            style={{ color: "inherit", textDecoration: "none" }}
            onClick={(e) => {
              if (!event.url) {
                e.preventDefault(); // Prevent the link from navigating
              }
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width="18"
              height="18"
              fill="rgba(45,45,45,1)"
            >
              <path d="M16 4C16.5523 4 17 4.44772 17 5V9.2L22.2133 5.55071C22.4395 5.39235 22.7513 5.44737 22.9096 5.6736C22.9684 5.75764 23 5.85774 23 5.96033V18.0397C23 18.3158 22.7761 18.5397 22.5 18.5397C22.3974 18.5397 22.2973 18.5081 22.2133 18.4493L17 14.8V19C17 19.5523 16.5523 20 16 20H2C1.44772 20 1 19.5523 1 19V5C1 4.44772 1.44772 4 2 4H16ZM15 6H3V18H15V6ZM7.4 8.82867C7.47607 8.82867 7.55057 8.85036 7.61475 8.8912L11.9697 11.6625C12.1561 11.7811 12.211 12.0284 12.0924 12.2148C12.061 12.2641 12.0191 12.306 11.9697 12.3375L7.61475 15.1088C7.42837 15.2274 7.18114 15.1725 7.06254 14.9861C7.02169 14.9219 7 14.8474 7 14.7713V9.22867C7 9.00776 7.17909 8.82867 7.4 8.82867ZM21 8.84131L17 11.641V12.359L21 15.1587V8.84131Z"></path>
            </svg>
            Go to meet link
          </a>
          {is48HoursOrMore(event?.slotDate, event?.start) && (
            <a
              rel="noopener noreferrer"
              className="d-flex align-items-center gap-1 mt-3 cursor-pointer"
              style={{ color: "inherit", textDecoration: "none" }}
              onClick={(e) => {
                
                handleReschedule(event.id, event?.userId, event?.coachingId,event?.hour);
               
                // setShow(true);
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="28"
                height="28"
                viewBox="0 0 28 28"
                fill="none"
              >
                <path
                  d="M19.1161 4.0883H18.7786V3.66548C18.7786 3.31524 18.4946 3.03125 18.1443 3.03125C17.7941 3.03125 17.5101 3.31524 17.5101 3.66548V4.0883H9.43285V3.66548C9.43285 3.31524 9.14886 3.03125 8.79862 3.03125C8.44839 3.03125 8.1644 3.31524 8.1644 3.66548V4.0883H7.82685C5.44074 4.0883 3.5 6.02904 3.5 8.41514V19.7044C3.5 22.0905 5.44074 24.0312 7.82685 24.0312H13.1473C13.4976 24.0312 13.7815 23.7473 13.7815 23.397C13.7815 23.0468 13.4976 22.7628 13.1473 22.7628H7.82685C6.1405 22.7628 4.76846 21.3907 4.76846 19.7044V11.1684H22.1745V13.7356C22.1745 14.0858 22.4585 14.3698 22.8087 14.3698C23.159 14.3698 23.443 14.0858 23.443 13.7356V8.41514C23.443 6.02904 21.5022 4.0883 19.1161 4.0883ZM4.76846 9.89994V8.41514C4.76846 6.7288 6.1405 5.35675 7.82685 5.35675H8.1644V5.77816C8.1644 6.1284 8.44839 6.41239 8.79862 6.41239C9.14886 6.41239 9.43285 6.1284 9.43285 5.77816V5.35675H17.5094V5.77816C17.5094 6.1284 17.7934 6.41239 18.1436 6.41239C18.4939 6.41239 18.7779 6.1284 18.7779 5.77816V5.35675H19.1154C20.8025 5.35675 22.1738 6.7288 22.1738 8.41514V9.89994H4.76846Z"
                  fill="#415385"
                />
                <path
                  d="M9.50215 14.2461H8.50923C8.15899 14.2461 7.875 14.5301 7.875 14.8803C7.875 15.2306 8.15899 15.5145 8.50923 15.5145H9.50215C9.85238 15.5145 10.1364 15.2306 10.1364 14.8803C10.1364 14.5301 9.85238 14.2461 9.50215 14.2461Z"
                  fill="#415385"
                />
                <path
                  d="M13.968 14.2461H12.975C12.6248 14.2461 12.3408 14.5301 12.3408 14.8803C12.3408 15.2306 12.6248 15.5145 12.975 15.5145H13.968C14.3182 15.5145 14.6022 15.2306 14.6022 14.8803C14.6022 14.5301 14.3175 14.2461 13.968 14.2461Z"
                  fill="#415385"
                />
                <path
                  d="M9.50215 18.418H8.50923C8.15899 18.418 7.875 18.702 7.875 19.0522C7.875 19.4024 8.15899 19.6864 8.50923 19.6864H9.50215C9.85238 19.6864 10.1364 19.4024 10.1364 19.0522C10.1364 18.702 9.85238 18.418 9.50215 18.418Z"
                  fill="#415385"
                />
                <path
                  d="M18.9916 15.1289C16.5372 15.1289 14.54 17.1253 14.54 19.5805C14.54 22.0349 16.5372 24.0314 18.9916 24.0314C21.4454 24.0314 23.4425 22.0349 23.4425 19.5805C23.4425 17.1253 21.4454 15.1289 18.9916 15.1289ZM18.9916 22.7629C17.2369 22.7629 15.8085 21.3352 15.8085 19.5798C15.8085 17.8244 17.2362 16.3967 18.9916 16.3967C20.747 16.3967 22.174 17.8244 22.174 19.5798C22.174 21.3352 20.7463 22.7629 18.9916 22.7629Z"
                  fill="#415385"
                />
                <path
                  d="M20.2983 18.9459H19.6267V18.2729C19.6267 17.9227 19.3427 17.6387 18.9925 17.6387C18.6423 17.6387 18.3583 17.9227 18.3583 18.2729V18.9459H17.686C17.3358 18.9459 17.0518 19.2299 17.0518 19.5801C17.0518 19.9303 17.3358 20.2143 17.686 20.2143H18.3583V20.8866C18.3583 21.2369 18.6423 21.5209 18.9925 21.5209C19.3427 21.5209 19.6267 21.2369 19.6267 20.8866V20.2143H20.2983C20.6485 20.2143 20.9325 19.9303 20.9325 19.5801C20.9325 19.2299 20.6492 18.9459 20.2983 18.9459Z"
                  fill="#415385"
                />
              </svg>
              Reschedule Session
            </a>
          )}
        </div>
      </div>
    </Tooltip>
  );

  const tooltipContentNotYetBooked = (
    <Tooltip id={`tooltip-${event.id}`} className="customtol notyetbooked">
      <div className="tooltipiner">
        <div className="d-flex align-items-start">
          <div className="text-nowraptitl">Not Yet Booked</div>
        </div>
        <div className="d-flex align-items-start mt-3">
          <div className="dsfedat">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
            >
              <path
                d="M14.6666 7.99967C14.6666 11.6797 11.6799 14.6663 7.99992 14.6663C4.31992 14.6663 1.33325 11.6797 1.33325 7.99967C1.33325 4.31967 4.31992 1.33301 7.99992 1.33301C11.6799 1.33301 14.6666 4.31967 14.6666 7.99967Z"
                stroke="#7E7E7E"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M10.4734 10.1202L8.40675 8.88684C8.04675 8.6735 7.75342 8.16017 7.75342 7.74017V5.00684"
                stroke="#7E7E7E"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>{" "}
            {`${startTimeFormat} -> ${endTimeFormat}`}
          </div>
        </div>
        {/* <div className="d-flex align-items-start particidsec">
          <p className="mb-0">Participants</p>
        </div> */}
        {/* <div className="d-flex gap-2 align-items-center borderbxo">
          <div className="img-box-ecclipse">
            <img
              src={event.profile ? event.profile : "/images/avatar.svg"}
              className="imgbx"
              alt="End user"
              loading="lazy"
            />
          </div>
          <div className="fnts">Session with {event.name}</div>
        </div> */}
        <div className="cursor-pointer linkdf mt-3">
          <a
            rel="noopener noreferrer"
            className="d-flex align-items-center gap-1"
            style={{ color: "#BA1717", textDecoration: "none" }}
            onClick={(e) => {
              console.log("eventclick: ", event);
              deleteSlotApi(event.id);
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="19"
              height="18"
              viewBox="0 0 19 18"
              fill="none"
            >
              <g clip-path="url(#clip0_3481_36915)">
                <path
                  d="M1.66657 18.0143C1.36804 18.0143 1.0693 17.9 0.842093 17.6726C0.385969 17.2167 0.385969 16.4796 0.842093 16.0237L16.509 0.356581C16.9649 -0.0993291 17.702 -0.0993291 18.1579 0.356581C18.614 0.812491 18.614 1.54963 18.1579 2.00554L2.49106 17.6726C2.26235 17.9011 1.9651 18.0143 1.66657 18.0143Z"
                  fill="#BA1717"
                />
                <path
                  d="M17.3334 18.0143C17.0349 18.0143 16.7364 17.9 16.509 17.6726L0.842093 2.00554C0.385969 1.54963 0.385969 0.812491 0.842093 0.356581C1.298 -0.0993291 2.03493 -0.0993291 2.49106 0.356581L18.1579 16.0237C18.614 16.4796 18.614 17.2167 18.1579 17.6726C17.9305 17.9011 17.632 18.0143 17.3334 18.0143Z"
                  fill="#BA1717"
                />
              </g>
              <defs>
                <clipPath id="clip0_3481_36915">
                  <rect
                    width="18"
                    height="18"
                    fill="white"
                    transform="translate(0.5)"
                  />
                </clipPath>
              </defs>
            </svg>
            Remove Slot
          </a>
        </div>
      </div>
    </Tooltip>
  );

  const tooltipContentCancelled = (
    <Tooltip id={`tooltip-${event.id}`} className="customtol cancelledsesion">
      <div className="tooltipiner">
        <div className="d-flex align-items-start">
          <div className="text-nowraptitl">Sale planner for beginners</div>
        </div>
        <div className="d-flex align-items-start">
          <div className="dsfedat">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
            >
              <path
                d="M14.6666 7.99967C14.6666 11.6797 11.6799 14.6663 7.99992 14.6663C4.31992 14.6663 1.33325 11.6797 1.33325 7.99967C1.33325 4.31967 4.31992 1.33301 7.99992 1.33301C11.6799 1.33301 14.6666 4.31967 14.6666 7.99967Z"
                stroke="#7E7E7E"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M10.4734 10.1202L8.40675 8.88684C8.04675 8.6735 7.75342 8.16017 7.75342 7.74017V5.00684"
                stroke="#7E7E7E"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>{" "}
            {`${startTimeFormat} -> ${endTimeFormat}`}
          </div>
        </div>
        <div className="d-flex align-items-start particidsec">
          <p className="mb-0">Participants</p>
        </div>
        <div className="d-flex gap-2 align-items-center borderbxo">
          <div className="img-box-ecclipse">
            <img
              src={event.profile ? event.profile : "/images/avatar.svg"}
              className="imgbx"
              alt="End user"
              loading="lazy"
            />
          </div>
          <div className="fnts">Session with {event.name}</div>
        </div>
        <div className="linkdf mt-3">
          <a
            rel="noopener noreferrer"
            className="d-flex align-items-center gap-1"
            style={{ color: "#BA1717", textDecoration: "none" }}
            onClick={(e) => {
              if (!event.url) {
                e.preventDefault(); // Prevent the link from navigating
              }
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="21"
              height="20"
              viewBox="0 0 21 20"
              fill="none"
            >
              <path
                d="M2.375 4.375H3.625V17.175C3.62665 17.758 3.85896 18.3166 4.27119 18.7288C4.68341 19.141 5.24203 19.3734 5.825 19.375H15.2C15.7786 19.3668 16.3309 19.1316 16.7377 18.7201C17.1445 18.3086 17.3734 17.7537 17.375 17.175V4.375H18.625C18.7908 4.375 18.9497 4.30915 19.0669 4.19194C19.1842 4.07473 19.25 3.91576 19.25 3.75C19.25 3.58424 19.1842 3.42527 19.0669 3.30806C18.9497 3.19085 18.7908 3.125 18.625 3.125H2.375C2.20924 3.125 2.05027 3.19085 1.93306 3.30806C1.81585 3.42527 1.75 3.58424 1.75 3.75C1.75 3.91576 1.81585 4.07473 1.93306 4.19194C2.05027 4.30915 2.20924 4.375 2.375 4.375ZM16.125 4.375V17.175C16.125 17.427 16.0249 17.6686 15.8468 17.8468C15.6686 18.0249 15.427 18.125 15.175 18.125H5.8C5.5524 18.1185 5.31714 18.0155 5.14435 17.8381C4.97156 17.6606 4.87491 17.4227 4.875 17.175V4.375H16.125Z"
                fill="#BA1717"
              />
              <path
                d="M8 1.875H13C13.1658 1.875 13.3247 1.80915 13.4419 1.69194C13.5592 1.57473 13.625 1.41576 13.625 1.25C13.625 1.08424 13.5592 0.925268 13.4419 0.808058C13.3247 0.690848 13.1658 0.625 13 0.625H8C7.83424 0.625 7.67527 0.690848 7.55806 0.808058C7.44085 0.925268 7.375 1.08424 7.375 1.25C7.375 1.41576 7.44085 1.57473 7.55806 1.69194C7.67527 1.80915 7.83424 1.875 8 1.875Z"
                fill="#BA1717"
              />
              <path
                d="M8.4248 15.625C8.59057 15.625 8.74954 15.5592 8.86675 15.4419C8.98396 15.3247 9.0498 15.1658 9.0498 15V7.5C9.0498 7.33424 8.98396 7.17527 8.86675 7.05806C8.74954 6.94085 8.59057 6.875 8.4248 6.875C8.25904 6.875 8.10007 6.94085 7.98286 7.05806C7.86565 7.17527 7.7998 7.33424 7.7998 7.5V15C7.7998 15.1658 7.86565 15.3247 7.98286 15.4419C8.10007 15.5592 8.25904 15.625 8.4248 15.625Z"
                fill="#BA1717"
              />
              <path
                d="M12.5752 15.625C12.741 15.625 12.8999 15.5592 13.0171 15.4419C13.1343 15.3247 13.2002 15.1658 13.2002 15V7.5C13.2002 7.33424 13.1343 7.17527 13.0171 7.05806C12.8999 6.94085 12.741 6.875 12.5752 6.875C12.4094 6.875 12.2505 6.94085 12.1333 7.05806C12.016 7.17527 11.9502 7.33424 11.9502 7.5V15C11.9502 15.1658 12.016 15.3247 12.1333 15.4419C12.2505 15.5592 12.4094 15.625 12.5752 15.625Z"
                fill="#BA1717"
              />
            </svg>
            Remove from Calender
          </a>
        </div>
      </div>
    </Tooltip>
  );

  return (
    <div
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      title=""
      className={event.is_locked ? "custom-event-box opacity-50" :"custom-event-box"}
    >
      {event.name && (
        <div className="d-flex gap-1 align-items-center borderbox">
          <div className="img-box-ecclipsecal">
            <img
              src={event.profile ? event.profile : "/images/avatar.svg"}
              className="imgbx"
              alt="End user"
              loading="lazy"
            />
          </div>
          <div className="tect-vx text-nowrap">Session with {event.name}</div>
        </div>
      )}

      {event.isBooking ? (
        <div className="d-flex gap-1 brtns mt-1 justify-content-between">
          <span className="eventtime">{`${startTimeFormat} - ${endTimeFormat}`}</span>
          <OverlayTrigger
            placement="top"
            show={event.is_locked?false:showTooltip}
            overlay={tooltipContentJoin}
          >
            <button className="joinbtn btns">Join</button>
          </OverlayTrigger>
        </div>
      ) : (
        <OverlayTrigger
          placement="top"
          show={event.is_locked?false:showTooltip}
          overlay={tooltipContentNotYetBooked}
        >
          <div className="notyetb">
            <div className="d-flex gap-1 align-items-center borderbox">
              <div className="img-box-ecclipsecal">
                <img
                  src="/images/avatar.svg"
                  className="imgbx"
                  alt="End user"
                  loading="lazy"
                />
              </div>
              <div className="tect-vx text-nowrap">Not Yet Booked</div>
            </div>
            <div className="d-flex gap-1 brtns mt-1 justify-content-between">
              <span className="eventtime">{`${startTimeFormat} - ${endTimeFormat}`}</span>
            </div>
          </div>
        </OverlayTrigger>
      )}

      {event.isCancelled && (
        <OverlayTrigger
          placement="top"
          show={event.is_locked?false:showTooltip}
          overlay={tooltipContentCancelled}
        >
          <div className="canselld">
            <div className="d-flex gap-1 align-items-center borderbox">
              <div className="img-box-ecclipsecal">
                <img
                  src={event.profile ? event.profile : "/images/avatar.svg"}
                  className="imgbx"
                  alt="End user"
                  loading="lazy"
                />
              </div>
              <div className="tect-vx text-nowrap">
                Session with {event.name}
              </div>
            </div>
            <div className="notyetb">
              <div className="d-flex gap-1 align-items-center borderbox">
                <div className="img-box-ecclipsecal">
                  <img
                    src="/images/avatar.svg"
                    className="imgbx"
                    alt="End user"
                    loading="lazy"
                  />
                </div>
                <div className="tect-vx text-nowrap">
                  Session with {event.name}
                </div>
              </div>
              <div className="d-flex gap-1 brtns mt-1 justify-content-between">
                <span className="eventtime">{`${startTimeFormat} - ${endTimeFormat}`}</span>
                <span className="cancelledbtn">Cancelled</span>
              </div>
            </div>
          </div>
        </OverlayTrigger>
      )}
    </div>
  );
};

export default CustomEvent;
